import { render, staticRenderFns } from "./productdashboard.vue?vue&type=template&id=47d43ee8"
import script from "./productdashboard.vue?vue&type=script&lang=js"
export * from "./productdashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports